import TextBlock from "./text-block";

export default TextBlock;